import { OSType } from '../typings/platforms'
import { Download } from '../typings/download'

export const getDownloadDataForSinglePlatform = (downloads: Download[], platform: OSType): Download | undefined => {
  return downloads.find((downloadItem) => downloadItem.platform === platform)
}
